export default class Helpers {
    constructor() {
        this.apiBaseUrl = `${riedlBamoHaendlerConfig.apiUrl}/riedl-catalog/v1`

        this.paginationWrapperId = 'product-pagination'
        this.paginationWrapperClass = 'product-pagination'
        this.paginationItemActiveClass = 'active'

        this.loaderId = 'my-loader'
    }

    static getQueryParameter(key) {
        const url = new URL(window.location.href);
        const searchParams = new URLSearchParams(url.search);

        return searchParams.get(key) ?? null
    }

    static updateQueryParameter(parameters) {
        const url = new URL(window.location.href);
        const searchParams = new URLSearchParams(url.search);

        for (let key in parameters) {
            if (parameters.hasOwnProperty(key)) {
                const value = parameters[key];

                if (searchParams.has(key)) {
                    searchParams.set(key, value);
                } else {
                    searchParams.append(key, value);
                }

                if (value == null || value === '') {
                    searchParams.delete(key)
                }
            }
        }

        url.search = searchParams.toString();

        if (Helpers.isDebugMode()) {
            console.log('updateQuery url', url, 'HREF', url.href)
        }

        window.history.pushState({path: url.href}, '', url.href);
    }

    static removeQueryParameter(parameters) {
        const url = new URL(window.location.href);
        const searchParams = new URLSearchParams(url.search);

        for (let key in parameters) {
            searchParams.delete(key)
        }

        url.search = searchParams.toString();
    }

    /**
     *
     * @param {string} param
     * @returns
     */
    getLocationParams(param) {
        const currentUrl = new URL(window.location.href)
        return currentUrl.searchParams.get(param)
    }

    /**
     *
     * @param {object} params (key: value)
     */
    changeLocationParams(params = {}) {
        const currentUrl = new URL(window.location.href)

        Object.entries(params).forEach((entry) => {
            const [key, value] = entry
            currentUrl.searchParams.set(key, value)

            if (key === '') {
                currentUrl.searchParams.delete(key)
            }
        })

        window.history.replaceState(null, null, currentUrl)
    }

    removeLocationParam(param) {
        const currentUrl = new URL(window.location.href)
        currentUrl.searchParams.delete(param)

        window.history.replaceState(null, null, currentUrl)
    }

    static getParamValueFromUrl(url, param) {
        const _url = new URL(url)
        return _url.searchParams.get(param)
    }

    static scrollToElement($element) {
        jQuery('html, body')
            .stop()
            .animate(
                {
                    scrollTop: $element.offset().top - 120,
                },
                800,
                'swing'
            )
    }

    hideElement() {
        // this.paginationWrapper = jQuery(`#${this.paginationWrapperId}`)

        // this.paginationWrapper.fadeOut(250)
        this.loader.show()
    }

    showElement() {
        // this.paginationWrapper = jQuery(`#${this.paginationWrapperId}`)

        // this.paginationWrapper.fadeIn(250)
        this.loader.hide()
    }

    static getViewportWidth() {
        var viewportwidth
        if (typeof window.innerWidth != 'undefined') {
            viewportwidth = window.innerWidth
        } else if (
            typeof document.documentElement != 'undefined' &&
            typeof document.documentElement.clientWidth != 'undefined' &&
            document.documentElement.clientWidth != 0
        ) {
            viewportwidth = document.documentElement.clientWidth
        } else {
            viewportwidth = document.getElementsByTagName('body')[0].clientWidth
        }
        return viewportwidth
    }

    static getViewportHeight() {
        var viewportHeight
        if (typeof window.innerHeight != 'undefined') {
            viewportHeight = window.innerHeight
        } else if (
            typeof document.documentElement != 'undefined' &&
            typeof document.documentElement.clientHeight != 'undefined' &&
            document.documentElement.clientHeight != 0
        ) {
            viewportHeight = document.documentElement.clientHeight
        } else {
            viewportHeight =
                document.getElementsByTagName('body')[0].clientHeight
        }
        return viewportHeight
    }

    static fadeInTransition(element) {
        // if (!element.hasClass('is_animating')) {
        //     element.addClass('is_animating')
            element.removeAttr('hidden')

            setTimeout(function () {
                element.addClass('fade-in')
                element.removeClass('fade')
            }, 1)

            // setTimeout(function () {
            //     element.removeClass('is_animating')
            // }, 400)
        // }
    }

    static fadeOutTransition(element) {
        // if (!element.hasClass('is_animating')) {
        //     element.addClass('is_animating')
            element.addClass('fade')
            element.removeClass('fade-in')
            element.attr('hidden', 'hidden')
            //
            // setTimeout(function () {
            //     element.removeClass('is_animating')
            // }, 400)
        // }
    }

    static setEqualHeight(
        $firstElement,
        $secondElement,
        viewportLargertThen,
        minHeight
    ) {
        if (
            typeof viewportLargertThen === 'undefined' ||
            viewportLargertThen === null
        ) {
            viewportLargertThen = 0
        }
        if (typeof minHeight === 'undefined' || minHeight === null) {
            minHeight = 0
        }
        $firstElement.css('height', 'auto')
        $secondElement.css('height', 'auto')
        if (this.getViewportWidth() > viewportLargertThen) {
            var h1 = $firstElement.outerHeight()
            var h2 = $secondElement.outerHeight()
            var maxHeight = 0
            if (h1 > h2) {
                maxHeight = h1
            } else {
                maxHeight = h2
            }
            if (minHeight > maxHeight) {
                maxHeight = minHeight
            }
            $firstElement.css('height', maxHeight)
            $secondElement.css('height', maxHeight)
        }
    }

    // Gleicht die Höhe von Elementen pro Zeile in einem Grid an.
    static setEqualHeightForRows(selection, cols) {
        var maxHeight = 0
        var actHeight = 0
        // counterLoop zählt immer 4 Elemente durch und wird danach wieder auf 0 gesetzt.
        var counterLoop = 0
        // counterAfter zählt die erste (Große) Schleifendurchgänge durch.
        var counterAfter = 0
        // Setzt bei window.resize() die Höhe der Elemente zuerst wieder auf "auto"
        selection.css('height', 'auto')
        //Den 'p-Tag' durchschleifen und jedes Grüppchen (alle 'col-te' Elemente) auf gleiche Höhe setzen
        selection.each(function () {
            counterAfter++
            // zählt die erste Schleife durch
            if (counterLoop < cols) {
                actHeight = jQuery(this).outerHeight()
                if (actHeight > maxHeight) {
                    maxHeight = actHeight
                }
                counterLoop++
                if (counterLoop >= cols) {
                    counterLoop = 0
                    // Zähler für die zweite Schleife
                    var count = 0
                    // Bestimmt ab welchem Element die Höhe gesetzt wird
                    var counterSelectOnlyThisFourElements = counterAfter - cols
                    // wird nur ausgeführt, wenn die nächste Gruppe durchlaufen ist
                    selection.each(function () {
                        // Setzt Höhe nur für die Gruppe
                        if (
                            count >= counterSelectOnlyThisFourElements &&
                            count < counterSelectOnlyThisFourElements + cols
                        ) {
                            jQuery(this).css('height', maxHeight)
                        }
                        if (count == counterSelectOnlyThisFourElements + cols) {
                            maxHeight = 0
                        }
                        count++
                    })
                }
            }
        })
    }

    static resetDownloadsHeadline() {
        console.warn('resetDownloadsHeadline()')

        const downloadsHeadline = $('#selected_item_headline')
        downloadsHeadline.html('').attr('hidden', 'hidden')
        // downloadsHeadline.fadeTo('slow', 0)

        this.fadeOutTransition(downloadsHeadline)
    }

    static setDownloadsHeadlineText(elementText) {
        const downloadsHeadline = $('#selected_item_headline')

        this.resetDownloadsHeadline()

        if (!!elementText === false) return;

        downloadsHeadline
            .html(`<h2 class="h3">${elementText}</h2>`)
            .removeAttr('hidden')

        this.fadeInTransition(downloadsHeadline)

        // downloadsHeadline.fadeTo('slow', 1)
    }

    static isDebugMode() {
        return Helpers.getCookie('debug_mode') && Helpers.getCookie('debug_mode') === 'true'
    }

    static getCookie(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
}
